import { Container, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { QRCodeSVG } from 'qrcode.react'

import Iconify from "src/components/iconify";
import Logo from "src/components/logo";
import { useBoolean } from "src/hooks/use-boolean";

import { BASE_URL } from "../../config-global";

export default function Header() {
    const theme = useTheme()

    const useQrCodeDialog = useBoolean(false)

    const url = BASE_URL

    return (
        <>
            <Container maxWidth='lg'>
                <Stack direction='row' justifyContent='space-between' py={4}>
                    <Logo height={24} width={150} url="/" />
                    <Stack spacing={1} direction='row' onClick={useQrCodeDialog.onTrue} sx={{ cursor: 'pointer' }}>
                        <Typography color={theme.palette.blueBrand[400]}>COMPARTILHAR</Typography>
                        <Iconify icon='lucide:qr-code' color={theme.palette.blueBrand[400]} />
                    </Stack>
                </Stack>
            </Container>
            <Dialog open={useQrCodeDialog.value} onClose={useQrCodeDialog.onFalse} maxWidth='xs' fullWidth>
                <DialogTitle>
                    <Stack alignItems='flex-end'>
                        <IconButton onClick={useQrCodeDialog.onFalse}><Iconify icon='lucide:x' /></IconButton>
                    </Stack>
                </DialogTitle>
                <DialogContent>
                    <Stack justifyContent='center' textAlign='center' alignItems='center' spacing={2} pb={4} pt={0}>
                        <Iconify icon='lucide:qr-code' width={32} color='grey.500' />
                        <Typography variant="h5">Escaneie o QR Code</Typography>
                        <Typography variant="paragraphM500">Veja os benefícios on-line.</Typography>
                        <QRCodeSVG value={url} />
                    </Stack>
                </DialogContent>
            </Dialog>
        </>
    )
}